import { AllTypeWidgets, BarSubType, LineSubType, PieSubType, TableSubType, TextSubType, TileSubType } from '../../types';
import { VennSubType } from '../../types/VennWidget.types';

type WidgetType = AllTypeWidgets['type'];

export const widgetTypeTitleMap = {
  [BarSubType.BarVertical]: 'Vertical Bars',
  [BarSubType.BarHorizontal]: 'Horizontal Bars',
  [BarSubType.StackedVertical]: 'Vertical Bars Stacked',
  [BarSubType.StackedHorizontal]: 'Horizontal Bars Stacked',
  [BarSubType.Percentage100_Vertical]: 'Vertical Bars Stacked 100%',
  [BarSubType.Percentage100_Horizontal]: 'Horizontal Bars Stacked 100%',
  [LineSubType.Line]: 'Line',
  [LineSubType.Spline]: 'Spline',
  [PieSubType.Pie]: 'Pie',
  [PieSubType.Donut]: 'Donut',
  [TableSubType.Table]: 'Table',
  [TableSubType.PivotTable]: 'Pivot Table',
  [TileSubType.Tile]: 'Tile',
  [TileSubType.Trend]: 'Trend',
  [TextSubType.Text]: 'Text',
} as const satisfies Record<Exclude<WidgetType, TileSubType.Score | VennSubType | PieSubType.PieWithNeedle>, string>;
